import client from '@/services/';

const state = () => ({
    all: [],
    one: [],
    societe: [],
    attestation: []
});

const getters = {
    all: state => state.all,
    one: state => state.one,
    societe: state => state.societe,
    attestation: state => state.attestation,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_SOCIETE: (state, obj) => {
        state.societe = obj;
    },
    SET_ATTESTATION: (state, obj) => {
        state.attestation = obj;
    }
};

const actions = {
    async getAll({ commit }, params = {}) {
        const { page = 0, size = 12, sort = '', after, before, userNom, userPrenoms, userMatricule, type, profil } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(after && { after }),
            ...(before && { before }),
            ...(userNom && { userNom }),
            ...(userPrenoms && { userPrenoms }),
            ...(userMatricule && { userMatricule }),
            ...(type && { type }),
            ...(profil && { profil }),
        }).toString();
        let { data } = await client.get(`/cotisation?${queryParams}`);
        commit("SET_ALL", data);
        return data;
    },
    async getAllConnecteeSociete(cxt, page = 0) {
        // Récupère toutes les cotisations des sociétés où l'utilisateur est gérant
        const { data } = await client.get('/cotisation/societes_gerant', {
            params: {
                page,
                size: 100,
                sort: 'createdAt,desc'
            }
        });
        cxt.commit("SET_SOCIETE", data);
        return data;
    },
    async getAllConnectee(cxt) {
        let data = await client.get('/cotisation/personne_physique');
        cxt.commit("SET_ONE", data.data);
        return data.data;
    },
    async mesAttestation(cxt) {
        let data = await client.get('/attestation/connected');
        cxt.commit("SET_ATTESTATION", data.data);
        return data.data;
    },
    async exportToExcel(_ctx, params = {}) {
        try {
            const { after, before, userNom, userPrenoms, userMatricule, type, profil } = params;
            const queryParams = new URLSearchParams({
                ...(after && { after }),
                ...(before && { before }),
                ...(userNom && { userNom }),
                ...(userPrenoms && { userPrenoms }),
                ...(userMatricule && { userMatricule }),
                ...(type && { type }),
                ...(profil && { profil }),
            }).toString();
            const url = queryParams ? `/cotisation/export/excel?${queryParams}` : '/cotisation/export/excel';
            const response = await client.get(url, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export Excel:', error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
